import React from 'react';
import CategoryProductOption from './Page';
import { CategoryProductOptionProvider } from 'providers';

export default function Page() {
  return (
    <CategoryProductOptionProvider>
      <CategoryProductOption />
    </CategoryProductOptionProvider>
  );
}
